<template>
  <div class="c-app ">
    <div class="">
      <Header v-if="show_header()"/>

      <main class="">
        <Loading/>

        <!-- <div class="header-padding" v-if="show_header()"></div> -->
        <div class="" >
          <transition name="fade" mode="out-in">
            <router-view :key="$route.path">
            
            </router-view>
          </transition>
        </div>

        <Dialog/>
      </main>

    </div>
  </div>
</template>

<script>

  import Loading from './Loading.vue'
  import Header from './Header.vue'
  import Dialog from './Dialog.vue'
  import {apiUrls} from '../config/api'
  import {bus} from '../main.js'

  export default {
    name: 'TheContainer',
    components: {
      Loading,
      Header,
      Dialog,
    },
    data() {
      return {
        dialog_show: false,
        dialog_title: '',
        dialog_summary: '',
        contosoChatHubProxy: null,
        broadcast:null,
        messageChannel:null,
        signalrReady: false,
      }
    },
    created () {
      this.onSignalrInvoke = (json_data) => {
        try {
          const json_obj = JSON.parse(json_data)
          this.signalr_invokes(json_obj.method, json_obj.data)
        } catch (e) {
          console.error('signalr_invokes failed', e, json_data)
        }
      }
      this.onSignalrUserReady = () => {
        this.bindSignalrClientHandlers()
        this.ensureHubStarted()
      }
    },
    mounted() {
      //old mounted
      // this.config_signalr();
      // bus.$on('show_dialog', (name) => {
      //   console.log('bus', name)
      //     this.dialog_show = true
      //     this.dialog_title = name[0]
      //     this.dialog_summary = name[1]
      //
      //   // setTimeout(this.load = name , 1000)
      // })
      // bus.$on('signalr_invokes', (json_data) => {
      //   var json_obj = JSON.parse(json_data)
      //   console.log('signalr_invokes', json_data)
      //  this.signalr_invokes(json_obj.method, json_obj.data)
      //   // setTimeout(this.load = name , 1000)
      // })
      //new mounted
      bus.$on('show_dialog', (name) => {
        console.log('bus', name)
        this.dialog_show = true;
        this.dialog_title = name[0];
        this.dialog_summary = name[1];

        // setTimeout(this.load = name , 1000)
      })

//******************************************
//******************************************
     if(1==0){//disable broadcast channel
       try {
         this.broadcast = new BroadcastChannel('count-channel');
         this.broadcast.onmessage = (event) => {
           console.log(event.data.payload);
         };

         this.broadcast.onmessage = (event) => {
           if (event.data && event.data.type === 'BroadcastToBus') {
             bus.$emit(event.data.event, event.data.args)
           }
         };
       } catch {
         console.log("broadcast not support")
       }
     }


      try {
        this.messageChannel = new MessageChannel();

        addEventListener('message', (event) => {
          // console.log("message channel received in container",event)

          // if (event.data && event.data.type === 'SignalInvoke') {
            if (event.data && event.data.type === 'BroadcastToBus') {
              bus.$emit(event.data.event, event.data.args)
            }
        });

      } catch(e) {
        console.log("message channel not support",e)
      }

//********************************************
//********************************************
      bus.$on('signalr_invokes', this.onSignalrInvoke)
      bus.$on('signalr_user_ready', this.onSignalrUserReady)

      if (!window.__zoodportalSignalRReady && typeof $ !== 'undefined' && $.connection) {
        window.__zoodportalSignalRReady = true
        this.signalrReady = true
        this.config_signalr()
      } else if (typeof $ !== 'undefined' && $.connection && $.connection.zoodKomakHub) {
        this.contosoChatHubProxy = $.connection.zoodKomakHub
        this.signalrReady = true
        this.bindSignalrClientHandlers()
        this.ensureHubStarted()
      }
//********************************************

//********************************************
//********************************************
//********************************************

    },
    beforeDestroy () {
      bus.$off('signalr_invokes', this.onSignalrInvoke)
      bus.$off('signalr_user_ready', this.onSignalrUserReady)
    },
    methods: {

      postMsgChannel(message) {
        // try{
        //   this.broadcast.postMessage(message);
        // }catch (e) {
        //   console.log("broadcast channel message error send")
        //
        // }
        try{
          window.postMessage(message, '*')
        }catch (e) {
          console.log("message channel message error send",e)

        }
      },
      show_header() {
        if (this.$router.currentRoute.fullPath == '/home-tab') {
          return false
        }
        if (this.$router.currentRoute.fullPath == '/message-tab') {
          return false
        }
        if (this.$router.currentRoute.fullPath == '/profile-tab') {
          return false
        }
        if (this.$router.currentRoute.fullPath == '/login') {
          return false
        }
        if (this.$router.currentRoute.fullPath == '/post-login') {
          return false
        }
        if (this.$router.currentRoute.fullPath == '/chat-detail') {
          return false
        }
        if (this.$router.currentRoute.fullPath == '/contacts') {
          return false
        }
        return true
      },
      getProfileUserId () {
        try {
          var profileRaw = localStorage.getItem('profile')
          if (!profileRaw) return null
          var user_data = JSON.parse(profileRaw)
          return user_data && user_data.UserId ? String(user_data.UserId) : null
        } catch (e) {
          return null
        }
      },
      bindSignalrClientHandlers () {
        if (typeof $ === 'undefined' || !$.connection || !$.connection.zoodKomakHub) return
        this.contosoChatHubProxy = $.connection.zoodKomakHub

        this.contosoChatHubProxy.client.getMessages = function (message) {
          console.log('get message', message)
          var payload = message
          if (typeof message === 'string') {
            try { payload = JSON.parse(message) } catch (e) { payload = message }
          }
          bus.$emit('signalr_methods', ['get_message', payload])
        }
        this.contosoChatHubProxy.client.GetNotifFromNewZk = function (message) {
          console.log('new notif zoodkomak', message)
          try {
            var json_mesage = typeof message === 'string' ? JSON.parse(message) : message
            if (json_mesage.func == 'online_request_confirmed') {
              var okMsg = 'درخواست ' + json_mesage.data.request.type_name + ' ' + json_mesage.data.request.group_name + ' ' + json_mesage.data.request.subgroup_name + ' ' +
                ' توسط ' + json_mesage.data.user.name + ' تایید شد.'
              bus.$emit('show_dialog', ['درخواست شما تایید گردید', okMsg])
              bus.$emit('online_request_updated', true)
            }
            if (json_mesage.func == 'online_request_canceled') {
              var cancelMsg = 'متاسفانه برای درخواست ' + json_mesage.data.request.type_name + ' ' + json_mesage.data.request.group_name + ' ' + json_mesage.data.request.subgroup_name + ' ' +
                ' کارشناسی یافت نشد '
              bus.$emit('show_dialog', ['درخواست لغو گردید', cancelMsg])
              bus.$emit('online_request_updated', true)
            }
          } catch (e) {
            console.error('GetNotifFromNewZk parse failed', e)
          }
        }
        this.contosoChatHubProxy.client.MessagesNotRead = function () {}
        this.contosoChatHubProxy.client.GetInboxRead = function (message) {
          console.log('GetInboxRead', message)
          var payload = message
          if (typeof message === 'string') {
            try { payload = JSON.parse(message) } catch (e) { payload = message }
          }
          bus.$emit('signalr_methods', ['read_message', payload])
        }
        this.contosoChatHubProxy.client.UserFired = function () {}
        this.contosoChatHubProxy.client.GetIsTyping = function (message) {
          var payload = message
          if (typeof message === 'string') {
            try { payload = JSON.parse(message) } catch (e) { payload = message }
          }
          bus.$emit('signalr_methods', ['is_typing', payload])
        }
        this.contosoChatHubProxy.client.GetUserOnlineStatus = function (message) {
          console.log('GetUserOnlineStatus', message)
          var payload = message
          if (typeof message === 'string') {
            try { payload = JSON.parse(message) } catch (e) { payload = message }
          }
          bus.$emit('signalr_methods', ['user_online', payload])
        }
        this.contosoChatHubProxy.client.getTechTrackInfo = function () {}
      },
      connectSignalrUser () {
        var self = this
        var userId = this.getProfileUserId()
        if (!userId) {
          console.log('SignalR connect skipped: profile/UserId missing')
          return Promise.resolve(false)
        }
        if (!this.contosoChatHubProxy) {
          this.contosoChatHubProxy = $.connection.zoodKomakHub
        }
        if ($.connection.hub.state !== $.signalR.connectionState.connected) {
          return Promise.resolve(false)
        }
        var args = JSON.stringify({ userId: userId })
        return this.contosoChatHubProxy.server.connect(args)
          .done(function () {
            console.log('Invocation of connect succeeded', userId)
          })
          .fail(function (error) {
            console.log('Invocation of connect failed. Error: ' + error)
          })
      },
      ensureHubStarted () {
        var self = this
        if (typeof $ === 'undefined' || !$.connection || !$.connection.hub) {
          return Promise.reject(new Error('SignalR missing'))
        }
        this.bindSignalrClientHandlers()
        if ($.connection.hub.state === $.signalR.connectionState.connected) {
          return Promise.resolve(this.connectSignalrUser())
        }
        if ($.connection.hub.state === $.signalR.connectionState.connecting) {
          return new Promise(function (resolve) {
            var tries = 0
            var timer = setInterval(function () {
              tries++
              if ($.connection.hub.state === $.signalR.connectionState.connected) {
                clearInterval(timer)
                resolve(self.connectSignalrUser())
              } else if (tries > 40) {
                clearInterval(timer)
                resolve(false)
              }
            }, 250)
          })
        }
        return $.connection.hub.start()
          .done(function () {
            console.log('Now connected, connection ID=' + $.connection.hub.id)
            return self.connectSignalrUser()
          })
          .fail(function () {
            console.log('Could not Connect!')
          })
      },
      config_signalr() {
        $.connection.hub.url = apiUrls.signalrURL
        this.bindSignalrClientHandlers()
        console.log(this.contosoChatHubProxy)
        this.start_hub_connection()
      },
      start_hub_connection() {
        var self = this
        this.ensureHubStarted()

        $.connection.hub.disconnected(function () {})
        $.connection.hub.stateChanged(function (change) {
          if (change.newState === $.signalR.connectionState.connected) {
            // after reconnect, user mapping must be restored
            self.connectSignalrUser()
          } else if (change.newState === $.signalR.connectionState.disconnected) {
            setTimeout(function () {
              self.ensureHubStarted()
            }, 1000)
          }
        })
      },
      signalr_invokes(method, args) {
        var self = this
        if (!this.contosoChatHubProxy && typeof $ !== 'undefined' && $.connection) {
          this.contosoChatHubProxy = $.connection.zoodKomakHub
        }
        if (!this.contosoChatHubProxy) {
          console.error('SignalR hub not ready')
          return
        }

        var run = function () {
          if (method == 'connect') {
            self.connectSignalrUser()
            return
          }
          if (method == 'send_message') {
            // identity first, then send — otherwise server may ACK without saving/echo
            Promise.resolve(self.connectSignalrUser()).then(function () {
              self.contosoChatHubProxy.server.sendMessageToGroup(args).done(function () {
                console.log('Invocation of send_message succeeded ')
              }).fail(function (error) {
                console.log('Invocation of send_message failed. Error: ' + error)
              })
            })
            return
          }
          if (method == 'is_typing') {
            self.contosoChatHubProxy.server.sendIsTyping(args).done(function () {
              console.log('Invocation of is_typing succeeded', args)
            }).fail(function (error) {
              console.log('Invocation of is_typing failed. Error: ' + error)
            })
            return
          }
          if (method == 'delete_connection') {
            self.contosoChatHubProxy.server.deleteConnection(args).done(function () {
              console.log('Invocation of delete_connection succeeded')
            }).fail(function (error) {
              console.log('Invocation of delete_connection failed. Error: ' + error)
            })
            return
          }
          if (method == 'add_online') {
            self.contosoChatHubProxy.server.addUserOnline(args).done(function () {
              console.log('Invocation of add_online succeeded')
            }).fail(function (error) {
              console.log('Invocation of add_online failed. Error: ' + error)
            })
            return
          }
          if (method == 'send_read') {
            self.contosoChatHubProxy.server.addToInboxRead(args).done(function () {
              console.log('Invocation of send_read succeeded')
            }).fail(function (error) {
              console.log('Invocation of send_read failed. Error: ' + error)
            })
          }
        }

        if ($.connection.hub.state === $.signalR.connectionState.connected) {
          run()
          return
        }

        this.ensureHubStarted().then(function () {
          if ($.connection.hub.state === $.signalR.connectionState.connected) {
            run()
          } else {
            console.error('SignalR not connected, state:', $.connection.hub.state)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
